import { FeaturKey, defaultFeature } from '@weenat/client/dist/FeatureToggle'
import { useToggleFeature } from 'app/state'
import { useEffect, useState } from 'react'
import { styled } from 'styled-components'
import Text from './Text'

const ToolbarContainer = styled(Flex)`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.85);
  padding: 6px 12px;
  overflow-x: auto;
  gap: 4px;
  flex-wrap: nowrap;
  align-items: center;
`

const FlagButton = styled(Flex)`
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 4px;
  cursor: pointer;
  flex-shrink: 0;
  border: 1px solid rgba(255, 255, 255, 0.15);

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`

const StatusDot = styled.div<{ $active: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background-color: ${(p) =>
    p.$active ? p.theme.colors.feedback.success[500] : p.theme.colors.feedback.error[500]};
`

const DevToolBar: FC = () => {
  const [isVisible, setIsVisible] = useState(true)
  const [features, setFeatures] = useToggleFeature()

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.metaKey && event.key === 'd') {
        event.preventDefault()
        setIsVisible((prev) => !prev)
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [])

  if (!import.meta.env.DEV || !isVisible) return null

  return (
    <ToolbarContainer>
      <Flex $flexDirection='row' $gap={'md'} $overflowX='auto' $flex={1}>
        {(Object.keys(defaultFeature) as FeaturKey[]).map((key) => (
          <FlagButton
            key={key}
            onClick={() => setFeatures((feats) => ({ ...feats, [key]: !feats[key] }))}
          >
            <StatusDot $active={features[key]} />
            <Text $color='grayscale.white' $fontSize='sm'>
              {key}
            </Text>
          </FlagButton>
        ))}
      </Flex>
      <Flex
        $ml={'auto'}
        $borderRadius={'sm'}
        $borderWidth={1}
        $borderColor={'alpha.white.10'}
        $p={'sm'}
        $backgroundColor={'alpha.white.10'}
        $alignItems='center'
        $justifyContent='center'
      >
        <Text
          $fontWeight='medium'
          $color='grayscale.white'
          $fontSize='sm'
          $fontVariantNumeric='tabular-nums'
          $textAlign='center'
        >
          ⌘ + D
        </Text>
      </Flex>
    </ToolbarContainer>
  )
}

export default DevToolBar
